/*
	This is a reducer that ONLY HOUSES ANALYTICS calls.
	It contains no internal state.
	It only subscribes to the actions in the signup ducks file,
	and composes the state to
*/

import Analytics from "./util/Analytics";

import {
	SUBMIT_RESET_SUCCESS,
	CONFIRM_RECAPTCHA_SUCCESS,
} from "ducks/login";


// ////////////////////////
// REDUCER ///////////////
// //////////////////////

export default function login(state, action) {
	switch (action.type) {
		case SUBMIT_RESET_SUCCESS: {
			Analytics.logUIEvent(Analytics.eventNames.accountSelectedResetPassword);
			return;
		}

		case CONFIRM_RECAPTCHA_SUCCESS: {
			const { payload: { score, isCaptchaShowing, page } } = action;
			Analytics.logUIEvent(
				Analytics.eventNames.recaptchaScore,
				{
					data: {
						score,
						isCaptchaShowing,
						page,
					},
				},
			);
			return;
		}

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/login.js